import React, {useEffect, useState} from "react";
import './styles/MyLesson.css';
import LessonTitle from "./LessonTitle";
import LessonItem from "./LessonItem";
import curriculaService from "../../../../services/curricula.service";
import Loading from "../../../helper/Loading";
import withUrlParams from "../../../HOC/withUrlParams";
import withAuth from "../../../HOC/withAuth";
import withErrorMessage from "../../../HOC/withErrorMessage";
import {useRecoilValue} from "recoil";
import {isOnlineState} from "../../../../states/states";
import CustomSweetAlert from "../../../helper/CustomSweetAlert";
import i18n from "i18next";

const MyLessons = (props) => {
    const {accessToken, currCode, handleError, uuid} = props;
    const [myLessons, setMyLessons] = useState(null);
    const isOnline = useRecoilValue(isOnlineState);

    useEffect(() => {
        if (accessToken) {
            getLessonInfo();
        }
    }, [accessToken, uuid]);


    const getLessonInfo = (token = '') => {
        if (isOnline) {
            curriculaService.getLessonInfo(currCode, token)
                .then(response => {
                    setMyLessons(response.data);
                })
                .catch((error) => {
                    handleError(error, "getLessonInfo");
                });
        }
    };

    if (myLessons) {
        return (
            <React.Fragment>
                <LessonTitle myLessons={myLessons}/>
                <div className="my-lesson">
                    <LessonItem myLessons={myLessons}/>
                </div>
            </React.Fragment>
        )
    }
    if (!isOnline) {
        return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false}/>;
    }
    return <Loading/>
};

export default withUrlParams(withAuth(withErrorMessage(MyLessons)));